export default __webpack_public_path__ + "static/media/icons8-remove-96.b58f9a6f.svg";